import React, { Component, Fragment } from 'react';
import { getSocialDialogueData } from '../../../api';
import ReactHtmlParser from 'react-html-parser';
import images from '../../../style/img/flag/images';

class SocialDialogueReport extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            countryData: {}
        }
    }

    loadData()
    {
        let filters = {
            countries: [{code:this.props.country}]
        }
        getSocialDialogueData(filters)
			.then((response)=> response)
			.then((res) => {
			
                let countryData = {};
                res.resultset.forEach(element =>{
                    countryData[element.countryCode] = {
                        countryName: element.countryName,
                        data: element.data
                    };
                });
                this.setState({countryData : countryData});
        });
    }

    countryData(country)
    {
        const currentCountryData = this.state.countryData[country];
        const flag = country == 'EU27_2020' ? images['eu28'] : images[country.toLowerCase()];
        if (currentCountryData)
        {
            return (
                <div className="box-rounded">
                    <header>
                        <img className="flags" src={flag} />
                        <h2 className="country title-section main-color">{currentCountryData.countryName}</h2>
                    </header>
                    <ul>
                        <li>
                            {currentCountryData.data['indicator1'] ? 
                            <Fragment>
                                <span className="country-data">{Math.round(currentCountryData.data['indicator1'])}</span>
                                <span className="data-text">%</span>
                            </Fragment>
                            :
                            <span className="country-data">-</span>}
                            <label>{this.props.literals.L20659}</label>
                        </li>
                        <li>
                            {currentCountryData.data['indicator2'] || country=='AT' ? 
                            <Fragment>
                                <span className="country-data">{country != 'AT' ? Math.round(currentCountryData.data['indicator2']) : 20}</span>
                                <span className="data-text">%</span>
                            </Fragment>
                            :
                            <span className="country-data">-</span>}
                            <label>{this.props.literals.L20660}</label>
                        </li>
                        <li>
                            {currentCountryData.data['indicator3'] ? 
                            <Fragment>
                                <span className="country-data">{Math.round(currentCountryData.data['indicator3'])}</span>
                                <span className="data-text">%</span>
                            </Fragment>
                            :
                            <span className="country-data">-</span>}
                            <label>{this.props.literals.L20661}</label>
                        </li>
                        <li>
                            {currentCountryData.data['indicator4'] ? 
                            <Fragment>
                                <span className="country-data">{Math.round(currentCountryData.data['indicator4'])}</span>
                                <span className="data-text">%</span>
                            </Fragment>
                            :
                            <span className="country-data">-</span>}
                            <label>{this.props.literals.L20662}</label>
                        </li>
                    </ul>
                </div>
            )
        }
    }

    componentDidMount()
    {
        this.loadData();
    }

    componentDidUpdate(prevProps)
    {
        if (prevProps.country != this.props.country)
        {
            this.loadData();
        }
    }

    render()
    {
        let euGreenBox = null;
        if (this.props.country == "EU27_2020")
        {
            euGreenBox = <div className="box-rounded no-data">
                {ReactHtmlParser(this.props.literals.L20634)}
            </div>
        }
        return (
            <div className="content-page">
                {this.props.country != "EU27_2020" ? this.countryData(this.props.country) : null}
                {this.countryData('EU27_2020')}
                {euGreenBox}
            </div>            
        )
    }
}

export default SocialDialogueReport